import Vue from 'vue'
import Router from 'vue-router'
import config from '@/config'
import {
  isIOS,
  getParams,
  getLocal,
  getUrlParam,
  isMiniApp,
  isApp,
} from '@/utils/utils'
import { getWeChatSignature } from '@/utils/wxconfig'
import storeConfigModel from '@store/models/config/config.model'
import ConfigModel from '@store/models/config/config.model'
// 门店系统相关
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import AgentMainController from '@/controllers/agentController/agentMain.controller'
import { Notify } from 'vant'
import {
  setCacheInfo,
  getCacheInfo,
} from '@/utils/http/modules/agent/agent.request'
import store from '@/store'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function replace(location) {
  return originalPush.call(this, location).catch(err => err)
}

// TODO: 利用 require.context 实现自动化加载 xxx.router.js
let routesList = []
const files = require.context('./modules', true, /\.router.js$/)
files.keys().forEach(key => {
  routesList = routesList.concat(files(key).default)
})
let timer = null
const router = new Router({
  mode: config.mode,
  base: config.routerPath,
  routes: [
    ...routesList,
    {
      path: '/clearstore',
      component: () =>
        import(/* webpackChunkName: "Clear" */ '../pages/clearStorage.vue'),
      meta: {
        title: '',
      },
    },
    {
      path: '/kateTransferPage',
      component: () =>
        import(
          /* webpackChunkName: "kateTransferPage" */ '../pages/kateTransferPage.vue'
        ),
      meta: {
        title: '',
      },
    },
    {
      path: '/trainInvite/:code',
      component: () =>
        import(
          /* webpackChunkName: "Clear" */ '../pages/study/trainInvite.vue'
        ),
      meta: {
        title: '加载中',
      },
    },
    {
      path: '/erp/invite',
      meta: { title: '接受邀请' },
      component: () =>
        import(
          /* webpackChunkName: "erp-invite" */ '@/pages/agent/erp/invite/index.vue'
        ),
    },
    {
      path: '/authEmpty',
      meta: { title: '授权中...' },
      component: () =>
        import(/* webpackChunkName: "authEmpty" */ '@/pages/empty.vue'),
    },
    {
      path: '*',
      name: '404',
      component: () =>
        import(/* webpackChunkName: "404" */ '../pages/error/404.vue'),
    },
  ],
})
router.beforeEach(async (to, from, next) => {
  /**
   * 门店系统与代理中心有联动的路由，由于可能跳转的地方遗漏判断，跳到代理中心
   * 这里做一层判断重定向回门店系统
   * isFromStore表示来源是门店系统
   * storePath 有值则表示有对应的门店系统路由
   */
  let isFromStore = from.meta?.vznaStore
  let storePath = to.meta?.storePath
  if (isFromStore && storePath) {
    let { name, meta, path, ...otherParams } = to
    next({ ...otherParams, path: storePath, replace: true })
  }
  let isStore = to.meta?.vznaStore
  if (isStore) {
    let { storeSign, ...otherQuery } = to.query
    if (storeSign) {
      try {
        let res = await getCacheInfo({
          key: storeSign,
        })
        let data = JSON.parse(res.dataObj)
        const localStorageData = data.localStorageData
        const cookie = data.cookie
        for (let key in localStorageData) {
          localStorage.setItem(key, localStorageData[key])
        }
        // jsCookie.set('zbvz_userid', cookie)
        next({ ...to, query: { ...otherQuery }, replace: true })
        return
      } catch (err) {
        console.log('otherQuery', err)
      }
    }
    let urlZb = to.query?.zbid
    let localZb = StoreController.zbId()
    if (urlZb && localZb && urlZb != localZb) {
      StoreController.goStoreLogin()
      return
    }
    if (StoreController.checkAccountType()) {
      StoreController.goStoreLogin()
      return
    }
  } else {
    StoreController.storeNotifyClose()
  }
  console.log('before 全局路由to', to)
  console.log('before 全局路由from', from)

  let isRetailFresh = AgentMainController.getBusinessModel() === 2
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title =
      typeof to.meta.title === 'function'
        ? to.meta.title(to, from, isRetailFresh)
        : to.meta.title
  }
  /* 路由发生变化修改页面topNavName */
  if (to.meta.topNavName) {
    to.meta.topNavName =
      typeof to.meta.topNavName === 'function'
        ? to.meta.topNavName(to, from, isRetailFresh)
        : to.meta.topNavName
  }
  if (to.path.includes('/shop/mall')) {
    const parmas = getParams()
    const zbid =
      Number(
        parmas.zbid ||
          parmas.zid ||
          parmas.zbId ||
          parmas.liveid ||
          parmas.liveId
      ) || 75999
    let newurl = `/plug-ins/#/SortIndex/${zbid}${window.location.search}`
    window.location.href = newurl
  } else {
    if (isStore) {
      // * 基础数据
      const t = Date.now()
      const userInfo = getLocal(ConfigModel['USER_INFO_KEY'])
      const zbid = getUrlParam('zbid') || getLocal(ConfigModel['ZBID_KEY'])
      // * 账户类型
      const accountType = getUrlParam('accountType')
        ? parseInt(getUrlParam('accountType'), 10)
        : userInfo?.type || 0
      // * 拼接公共参数（zbid，accountType）
      const newQuery = {
        ...to.query,
        ...(zbid ? { zbid: `${zbid}` } : {}),
        accountType: `${accountType}`,
        v: to.query.v || t,
      }
      if (to.meta?.permCode) {
        await store.dispatch('getPermissions')
        let permCode = to.meta.permCode
        if (typeof permCode === 'function') {
          permCode = permCode(to.query)
        }
        if (!store.getters.hasPermi(permCode)) {
          StoreController.goStore404()
          return
        }
      }
      if (JSON.stringify(to.query) !== JSON.stringify(newQuery)) {
        next({ path: to.path, query: newQuery })
      } else {
        next()
      }
    } else {
      next()
    }
  }
})
router.afterEach((to, from, next) => {
  /**
   * 用户观看直播拦截
   * 若打开「禁用H5观看页」开关,即使之前用户拿到了H5链接,打开也提示无法观看
   */
  if (
    to.meta.h5forbidden &&
    zbvd.h5forbidden &&
    !(to.name === 'period' && isMiniApp()) &&
    !isApp() &&
    !(to.query.banInline == 1 || getLocal('banInline') == 1)
  ) {
    location.replace(
      `/live/m/error/h5forbidden?zbid=${window.zbvd.zbid}&promptType=h5forbidden`
    )
  }
  // 处理苹果从我的票务跳转转增票务页分享不了问题
  if (from && from.path.includes('/ActMyTicket') && isIOS()) {
    if (window.location.href.includes('?')) {
      window.location.href = window.location.href + '&v=' + new Date().getTime()
    } else {
      window.location.href = window.location.href + '?v=' + new Date().getTime()
    }
    console.log(location.href)
  }
  if (to.meta.isNotShare) {
    console.log('进入 after isNotShare')
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    timer = setTimeout(async () => {
      await getWeChatSignature()
    }, 1000)
  }
  /**
   * * 大健康门店系统
   */
  if (to.meta[storeConfigModel['ROUTE_META_KEY']]) {
    // * 校验登录状态
    if (!StoreController.storeLoginStatus()) {
      StoreController.goStoreLogin()
    }
    // * 校验url中的zbid是否有变动
    if (
      to.query.zbid &&
      to.query.zbid != getLocal(storeConfigModel['ZBID_KEY'])
    ) {
      StoreController.goStoreLogin()
    }
    // * 获取门店状态
    StoreController.getCurrentStoreInfoData()
    // * 根据账号类型初始化主题样式变量
    StoreController.setTheme()
  }
  Notify.clear()
  // if (to.meta.isNotShare) {
  //   // 只有工作台 显示菜单 但是隐藏分享 保留收藏
  //   if (to.name === 'agentIndex' && to.query.activeNum === '0') {
  //     console.log('进入 after 工作台')
  //     setTimeout(async () => {
  //       console.log('进入 after 工作台 getWeChatSignature')
  //       await getWeChatSignature({
  //         menus: [
  //           'menuItem:share:appMessage',
  //           'menuItem:share:timeline',
  //           'menuItem:share:qq',
  //           'menuItem:share:weiboApp',
  //           'menuItem:share:facebook',
  //           'menuItem:share:QZone'
  //         ],
  //         isshare: true
  //       })
  //     }, 3000)
  //   } else {
  //     console.log('进入 after isNotShare')
  //     setTimeout(async () => {
  //       console.log('进入 after getWeChatSignature')
  //       await getWeChatSignature()
  //     }, 3000)
  //   }
  // }
})

export const useRoute = () => {
  return router.currentRoute
}
export default router
